'use strict';

import analytics from './analytics';
import countries from './countries';
import dialog from './dialog';
import modalExport from './modal';
const modal = modalExport.global;

import quickview from './quickview';
import minicart from './minicart';
import page from './page';
import rating from './rating';
import searchplaceholder from './searchplaceholder';
import searchsuggestRedesign from './redesign/searchsuggest';
import searchsuggestDefault from './searchsuggest';
import tooltip from './tooltip';
import util from './util';
import validator from './validator';
import slick from './slick';
import tls from './tls';
import video from './video';
import headerMenu from './header-menu';
import footerSelector from './footer-selector';
import newsletter from './newsletter';
import inputEntry from './input-entry';
import recommendations from './pages/product/recommendations';
import narspro from './narspro';
import jsform from './jsform';
import skedge from './skedge';
import productTile from './product-tile';
import bambuser from './bambuser/bambuser';
import login from './login';
import newsletterModule from './newsletter-module';
import appHelper from './app-helper';
import inputField from './input-field';
import cartRedesign from './pages/cart';
import redesignLogin from './redesign/login-redesign';
import copyTextToClipboard from './copy-text-clipboard';
import adventCalendarBlock from './advent-calendar';
import immersiveExperience from './immersive-experience';
import accessibility from './accessibility';
import jqueryExt from './jquery-ext';
import cookiePrivacy from './cookieprivacy';
import captcha from './captcha';
import campaign from './campaign';

// Pages
import account from './pages/account';
import cart from './pages/cart';
import checkout from './pages/checkout';
import compare from './pages/compare';
import product from './pages/product';
import registry from './pages/registry';
import orderconfirmation from './pages/order-confirm';
import search from './pages/search';
import tutorial from './pages/tutorial';
import storefront from './pages/storefront';
import wishlist from './pages/wishlist';
import storelocator from './pages/storelocator';
import checkorder from './pages/checkorder';
import content from './pages/content';
import dialogSDKInit from './pages/product/dialogSDK';

const searchsuggest =
    $('#suggestions-redesign-enabled').length > 0
        ? searchsuggestRedesign
        : searchsuggestDefault;

// If jQuery has not been loaded, load from Google CDN
if (!window.jQuery) {
    const s = document.createElement('script');

    s.setAttribute(
        'src',
        'https://ajax.googleapis.com/ajax/libs/jquery/3.5.0/jquery.min.js'
    );
    s.setAttribute('type', 'text/javascript');

    document.getElementsByTagName('head')[0].appendChild(s);
}

jqueryExt();
cookiePrivacy();
captcha();
util.bindGlobalEvents();

// Initialize campaign form events
campaign.init();

function initializeEvents() {
    cartRedesign.multiSelectSample();
    cartRedesign.addSelectedSamplesCart();

    var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];

    $('body')
        .on('keydown', 'textarea[data-character-limit]', function (e) {
            var text = $.trim($(this).val()),
                charsLimit = $(this).data('character-limit'),
                charsUsed = text.length;

            if ((charsUsed >= charsLimit) &&
                (controlKeys.indexOf(e.which.toString()) < 0)) {
                e.preventDefault();
            }
        })
        .on('change keyup mouseup', 'textarea[data-character-limit]', function () {
            var text = $.trim($(this).val()),
                charsLimit = $(this).data('character-limit'),
                charsUsed = text.length,
                charsRemain = charsLimit - charsUsed;

            if (charsRemain < 0) {
                $(this).val(text.slice(0, charsRemain));
                charsRemain = 0;
            }

            $(this)
                .closest('.field-wrapper')
                .find('.char-remain-count')
                .html(charsRemain);
        });

    /**
     * initialize search suggestions
     */
    var $searchContainer =
        !$('#suggestions-redesign-enabled').length > 0
            ? $('.header-search-container')
            : $('.search-redesign-container');

    searchsuggest.init($searchContainer, Resources.SIMPLE_SEARCH);

    // add show/hide navigation elements
    $('.secondary-navigation .toggle').click(function () {
        $(this).toggleClass('expanded').next('ul').toggle();
    });

    // add generic toggle functionality
    $('.toggle').next('.toggle-content').hide();

    $('.toggle').click(function () {
        $(this).toggleClass('expanded')
            .next('.toggle-content')
            .toggle();
    });

    /**
     * Quick View (keep only one implementation)
     */
    quickview.bindQvButton($('a[data-quickview-product]'));

    $(document).on('submit', '.login-modal.noGuest form', function (e) {
        var $form = $(this);

        if (!$form.valid()) {
            e.preventDefault();
        }
    });

    $(document).on('click', 'a.goto', function (e) {
        var $this = $(this);
        var $target = $($this.attr('href'));

        if (!$target.length) {
            return true;
        }

        e.preventDefault();

        $('body,html').animate({
            scrollTop: $target.offset().top - 120
        }, 500);

        return false;
    });

    // subscribe email box
    var $subscribeEmail = $('.subscribe-email');

    if ($subscribeEmail.length > 0) {
        $subscribeEmail.focus(function () {
            var val = $(this.val());

            if (val.length > 0 &&
                val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
                return;
            }

            $(this).animate({
                color: '#999999'
            }, 500, 'linear', function () {
                $(this).val('').css('color', '#333333');
            });
        }).blur(function () {
            var val = $.trim($(this.val()));

            if (val.length > 0) {
                return;
            }

            $(this)
                .val(Resources.SUBSCRIBE_EMAIL_DEFAULT)
                .css('color', '#999999')
                .animate({
                    color: '#333333'
                }, 500, 'linear');
        });
    }

    $('.privacy-policy').on('click', function (e) {
        e.preventDefault();

        dialog.open({
            url: $(e.target).attr('href'),
            options: {
                height: 600
            }
        });
    });

    if ($('.order-confirmation-details').length) {
        sessionStorage.removeItem('isGift');
        sessionStorage.removeItem('giftMessage');
    }

    var url = Urls.passwordReset;

    if ($('.reset-password-link').length) {
        if (location.protocol === 'https:') {
            url = Urls.securePasswordReset;
        }

        $('.reset-password-link').each(function () {
            $(this).find('a').attr('href', url);
        });
    }

    if ($('.user-recognized').length) {
        if (location.protocol === 'https:') {
            url = Urls.securePasswordReset;
        }

        $('.user-recognized').find('a').attr('href', url);
    }

    // Keep Version 1 behavior
    appHelper.addSummaryScrollbar();

    $(window).on('load resize', function () {
        if ($(window).width() > 768) {
            var topBannerMargin =
                $('#minimized-header-container .top-banner')
                    .css('margin');

            if (topBannerMargin == '0px') {
                var topBannerPadding =
                    $('#minimized-header-container .top-banner')
                        .css('padding');

                $('.narsprolanding-content .html-slot-container .heading-narspro-makeup')
                    .css('margin', topBannerPadding);
            } else {
                $('.narsprolanding-content .html-slot-container .heading-narspro-makeup')
                    .css('margin', topBannerMargin);
            }
        }
    });

    $(document).ready(function () {
        appHelper.crossNavBarHandler();
        $(document).on('click', '.filter-by-text', function () {
            $('.filter-line').slideToggle('fast');
            $(this).find('.arrow-up, .arrow-down').toggle();
        });
    });

    $(document).on(
        'click',
        '.search-result-options.slp-filters .refinement .toggle',
        function () {
            $('#category-level-1').toggle();
            $('.slp-filters .refinements').toggleClass('underline');
        }
    );

    // Artist / Boutique navigation
    $('#artist-bio-down-arrow').click(function () {
        $('html, body').animate({
            scrollTop: $('#moreAboutartist').offset().top - 100
        }, 1000);
    });

    $('#boutique-details-down-arrow').click(function () {
        $('html, body').animate({
            scrollTop: $('#boutique-services-block').offset().top - 100
        }, 1000);
    });

    $('#artist-more-about').on('click', function () {
        $('html, body').animate({
            scrollTop:
                $('#moreAboutartist').offset().top -
                ($(window).width() > 1024 ? 120 : 90)
        }, 1000);
    });

    $('#artist-life').on('click', function () {
        $('html, body').animate({
            scrollTop:
                $('#lifeOfartist').offset().top -
                ($(window).width() > 1024 ? 170 : 150)
        }, 1000);
    });

    $('#artist-must-have').on('click', function () {
        $('html, body').animate({
            scrollTop:
                $('#artistsMustHave').offset().top -
                ($(window).width() > 1024 ? 130 : 100)
        }, 1000);
    });

    $('#artist-jennys-video').on('click', function () {
        $('html, body').animate({
            scrollTop:
                $('#artist-video-block').offset().top -
                ($(window).width() > 1024 ? 130 : 100)
        }, 1000);
    });

    $('#artist-shopthelook').on('click', function () {
        $('html, body').animate({
            scrollTop:
                $('.adp-relatedsection').offset().top -
                ($(window).width() > 1024 ? 150 : 100)
        }, 1000);
    });

    // PDP redirect from QV
    $('#cart-table .item-details .item-edit-details a').on('click', function () {

        setTimeout(function () {

            var bvReviewURL =
                $('.quickview-modal .pdp-main .product-title>a')
                    .attr('href');

            $('.quickview-modal .bv-write-review-container button')
                .removeClass('bv-write-review');

            $('.quickview-modal .bv-write-review-container button')
                .on('click', function (e) {

                    e.preventDefault();

                    window.setTimeout(function () {
                        window.location.href =
                            bvReviewURL + '#writeReview';
                    }, 50);
                });

        }, 1000);
    });

    $(document).on(
        'change',
        '.contact-form-wrapper select.country',
        function (e) {
            e.preventDefault();
            $('#contactus-country').val($(this).val());
        }
    );

    if (window.location.href.indexOf('writeReview') > 0) {
        setTimeout(function () {
            jQuery('.bv-write-review')[0].click();
        }, 1000);
    }


    $(window).on('load', function () {

        $('.reveal-overlay').each(function () {
            if ($(this).children().length < 1) {
                $(this).remove();
            }
        });

        $(document).on(
            'click',
            '.close-button, .modal-close, .modal-close-outer, .modal-close-btn',
            function () {
                if ($('.reveal-overlay').html().trim().length === 0) {
                    $('.reveal-overlay:empty').remove();
                }
            }
        );

        if ($('.utility-nav').length === 0 &&
            $(window).width() < 768) {

            $('#main').addClass('spacing-top');
        }
    });

    $(window).on('load', function () {

        if (window.location.search) {

            const urlParams =
                new URLSearchParams(window.location.search);

            const forgotPassword =
                urlParams.get('forgotpassword') === 'true';

            if (forgotPassword) {

                const loginWrapper =
                    $('#login-wrapper-new');

                $('.login-form-content-new')
                    .addClass('visually-hidden');

                loginWrapper.find('.divider')
                    .addClass('visually-hidden');

                loginWrapper.find('.social-login-holder')
                    .addClass('visually-hidden');

                $('.reset-account-part')
                    .removeClass('visually-hidden');

                $('.sign-in-wrapper a.myaccount')
                    .trigger('click');
            }

            if (urlParams.get('passwordchanged') === 'true') {
                $('.sign-in-wrapper a.myaccount')
                    .trigger('click');
            }
        }
    });

    const overlayVideoWrapper = $('#video-overlay');
    const overlayVideo = $('#overlay-video-container video:visible')[0];

    if (document.readyState !== 'loading') {
        if (overlayVideo) {
            overlayVideoWrapper.addClass('video-overlay');
            $('body').addClass('no-scroll');
        }
    }

    $(window).on('load', function () {
        if (
            isFullyHidden('.reveal-overlay') &&
            isFullyHidden('#onetrust-banner-sdk')
        ) {
            playVideo(overlayVideo);
        }
    });

    $('.reveal-overlay .close-button').on(
        'click',
        function () {

            if (overlayVideo) {

                document.activeElement.blur();

                $('.reveal-overlay').hide();

                $('body, html')
                    .removeClass('is-reveal-open');

                playVideo(overlayVideo);
            }
        }
    );

    $('body').on(
        'click',
        '#onetrust-banner-sdk .onetrust-close-btn-handler,' +
        '#onetrust-pc-btn-handler,' +
        '#onetrust-accept-btn-handler,' +
        '#accept-recommended-btn-handler,' +
        '#onetrust-consent-sdk .ot-pc-refuse-all-handler,' +
        '#onetrust-consent-sdk .save-preference-btn-handler',
        function (e) {
            e.preventDefault();
            playVideo(overlayVideo);
        }
    );

    overlayVideo?.addEventListener('ended', () => {

        $('body').removeClass('no-scroll');

        overlayVideoWrapper.hide();

        $('#main-video-container video:visible')[0]
            .play()
            .catch((err) => {
                console.error('Autoplay failed:', err);
            });
    });

    appHelper.validateGuestUserLogin();

    util.openModalFromContentAsset(
        $('a.narspro-revamp-modal')
    );

    util.openModalFromContentAsset(
        $('a.narspro-need-help-modal')
    );

    util.openModalFromContentAsset(
        $('a.narspro-docs-list-modal')
    );

    function playVideo (overlayVideo) {
    setTimeout(function() {
        if (overlayVideo && isFullyHidden('.reveal-overlay') && isFullyHidden('#onetrust-banner-sdk')) {
            overlayVideo.autoplay = true;
            overlayVideo.muted = true;
            overlayVideo.play().catch((err) => {
                console.error('Autoplay failed:', err);
            });
        }
    }, 1000);
}

    function isFullyHidden(selector) {
        const element = $(selector);
        return (
            element.length === 0 || (!element.is(':visible') || element.css('visibility') === 'hidden')
        );
    }

    $('.reveal-overlay, .close-button, .modal-close, .modal-close-outer, .modal-close-btn, .paypal-button.terms-check').on('click', function () {
        $('.reveal-overlay:empty').remove();
    });
}

/**
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js specific styles.
 */
function initializeDom() {
    // add class to html for css targeting
    $('html').addClass('js');

    headerMenu.updateMainMargin(); // Function to update the margin-top of the main wrapper based on the header height

    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $('html').addClass('infinite-scroll');
    }

    // load js specific styles
    util.limitCharacters();

    // initialize material input events
    inputField.init();
    
    recommendations.init();
    productTile.init();
    copyTextToClipboard.init();
    adventCalendarBlock.init();
    $('.footer-persistant .footer-persistant-panels a#down-arrow-link').on('click touchstart', function(){
     	$('.footer-persistant .footer-persistant-panels').hide();
    });
    
    $('.footer-persistant-link').on('click touchstart', function(){
     	$('.footer-persistant .footer-persistant-panels').show();
    });
    
    $('.footer-persistant').on('mouseover', function(){
    	$('.footer-persistant-panels').show();	
    })
        .on('mouseout', function(){
    	$('.footer-persistant-panels').hide();
        });

    
    $(document).click(function(e) {
	  if ($(e.target).closest('.footer-persistant').length === 0) {
		  $('.footer-persistant .footer-persistant-panels').hide();
	  }
    });
}

$(window).on('load', function () {

    // remove tokywoky widget if no channel is selected
    if ($('.tokywoky-widget').length && !$('[id^="toky_channel_"]').find('iframe').length) {
        $('.tokywoky-widget').addClass('hidden');
    }
    
    $('.reveal-overlay').each(function() { 
        if($(this).children().length < 1 || $(this).html().trim().length == 0) 
            $(this).remove() 
    });
});

var pages = {
    account,
    cart,
    checkout,
    compare,
    product,
    registry,
    orderconfirmation,
    search,
    tutorial,
    storefront,
    wishlist,
    storelocator,
    checkorder,
    content
};

var app = {
    init: function() {
        $(document).foundation();

        if (document.cookie.length === 0) {
            $('<div/>')
                .addClass('browser-compatibility-alert')
                .append(
                    $('<p/>')
                        .addClass('browser-error')
                        .html(Resources.COOKIES_DISABLED)
                )
                .appendTo('#browser-check');
        }

        $('.mobile-only').each(function () {
            // Check if the shadow element inside <bam-playlist> has any content
            const bamPlaylist = $(this).find('bam-playlist')[0];

            if (
                bamPlaylist &&
                bamPlaylist.shadowRoot &&
                bamPlaylist.shadowRoot.innerHTML.trim() === ''
            ) {
                // Remove margin if shadow DOM is empty
                $(this).addClass('no-margin');
            }
        });

        initializeDom();
        initializeEvents();

        // execute accessibility enhancements
        accessibility.init();

        // Common handlers
        appHelper.backToTopHandler();
        appHelper.backToTopPLP();
        appHelper.minimizedHeaderHandler();
        appHelper.resetFooterError();
        appHelper.responsiveMegaMenu();
        appHelper.searchMenuEvent();

        if ($(window).width() < 768) {
            appHelper.crossNavBarHandler();
        }

        // init specific global components
        if (SitePreferences.ENABLE_LOGIN_REDESIGN) {
            redesignLogin.init();
        }

        analytics.init();
        countries.init(); 
        tooltip.init();
        minicart.init();
        validator.init();
        rating.init(); 
        slick.init();
        searchplaceholder.init();
        headerMenu.init();
        video.init();
        login.init();

        footerSelector.languageSelector();
        footerSelector.countrySelector();

        newsletter.newsletterHeader();
        newsletter.isNewsletterEnabled();
        newsletter.newsletterPersistentFooter();
        newsletter.offerNewsletter();
        newsletter.newsletterMobile();
        newsletter.signUpEventListener();

        newsletterModule.init();
        inputEntry();
        appHelper.playVideoHandler();

        // Components
        narspro.init(); 
        skedge.init();
        bambuser.init();

        appHelper.tutorialSliderInit();
        util.updateWithCsrfInputAjax(); // add csrf for post ajax call

        // Additional page initialization from first version
        appHelper.initPageModule(pages);

        // Dialog SDK is initialized per-page for PDP; initialize it globally for all other pages
        dialogSDKInit();

        // Check TLS status if indicated by site preference
        if (SitePreferences.CHECK_TLS === true) {
            tls.getUserAgent();
        }

        // execute immersive experience
        immersiveExperience.init();
    }
};

//general extension functions
(function() {
    String.format = util.generalExtension
})();

// initialize app
$(document).ready(function () {
    app.init();
});

// expose global app obj for 3rd party integrations
window.app = {
    quickView: quickview,
    minicart: minicart,
    user: window.User,
    SCemailUrl: window.Urls.SCemailUrl,
    Product: {},
    tagmanager: analytics.tagmanager,
    gtmInternalPromotion: analytics.gtmInternalPromotion,
    jsform: jsform,
    skedge: skedge,
    modal:modal,
    recommendations : recommendations,
    productTile: productTile,
    immersiveExperience: immersiveExperience
};

// expose global saveURL to support legacy Composed integration
window.saveURL = window.Urls.saveConsultationURL;
// summary scroll bar global scope
window.addSummaryScrollbar = appHelper.addSummaryScrollbar;
window.scrollToTop = util.scrollToTop;
